import React from "react";
import { Spinner as ChakraSpinner, SpinnerProps } from "@chakra-ui/react";

const Spinner = ({ ...props }: SpinnerProps) => {
  return <ChakraSpinner {...props} />;
};

export default Spinner;
